import { useKeycloak } from "@react-keycloak/web";
import React, { useContext, useState } from "react";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import * as _api from "../../Apis/Criteres_apis";
import { userContext } from "../../Stores/Store";

const ModalCreateBareme = (props) => {
  const [bareme, setBareme] = useState({});
  const { keycloak, initialized } = useKeycloak();
  const handleClose = () => props.show(false);
  const [errorForm, setErrorForm] = useState();
  const user = useContext(userContext);

  const handleChange = (e) => {
    setBareme({ ...bareme, [e.target.name]: e.target.value });
  };

  const addBareme = () => {
    _api.putBareme(keycloak.token, user.competitionid, user.skillid, bareme).then((results) => {
      if (results) {
        props.maj(results, "addBareme"); //on renvoie le résultat vers le state à modifier du parent
        props.show(false);
      } else {
        setErrorForm("Une erreur technique s'est produite");
      }
    });
    props.maj(bareme, "addBareme");
    props.show(false);
  };

  return (
    <Modal
      className="modal_app"
      show={props.show}
      onHide={handleClose}
      backdrop="static"
      centered="true"
      size="lg"
    >
      <Modal.Header closeButton>
        <Modal.Title>Créer un barème</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={(e) => e.preventDefault()}>
          <Row>
            <Col>
              <Form.Group className="mb-3">
                <Form.Control
                  placeholder="Nom du barème"
                  name="name"
                  value={bareme.name}
                  onChange={handleChange}
                  required
                />
              </Form.Group>
            </Col>
          </Row>
        </Form>
      </Modal.Body>

      <Modal.Footer>
        <Button onClick={() => addBareme()}>Ajouter</Button>
        <Button variant="secondary" onClick={handleClose}>
          Fermer
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalCreateBareme;
